var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { ListItem as MuiListItem } from '@mui/material';
import Divider from '../../Divider';
import Text from '../../Text';
import colors from '../../../themes/colors';
var NavbarListItem = styled(MuiListItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 48px;\n  padding: 8px;\n  border-radius: 4px;\n  cursor: ", ";\n  background-color: ", ";\n  transition: background-color 0.2s ease-in-out;\n  display: flex;\n  gap: 12px;\n\n  ", "\n\n  & p {\n    font-weight: ", ";\n  }\n"], ["\n  min-height: 48px;\n  padding: 8px;\n  border-radius: 4px;\n  cursor: ", ";\n  background-color: ", ";\n  transition: background-color 0.2s ease-in-out;\n  display: flex;\n  gap: 12px;\n\n  ", "\n\n  & p {\n    font-weight: ", ";\n  }\n"])), function (_a) {
    var disableHover = _a.disableHover;
    return (disableHover ? 'default' : 'pointer');
}, function (_a) {
    var disableHover = _a.disableHover, active = _a.active;
    return (!disableHover && active ? colors.neutral5 : 'transparent');
}, function (_a) {
    var disableHover = _a.disableHover;
    if (disableHover)
        return '';
    return "\n      &:hover {\n        background-color: ".concat(colors.neutral0, ";\n      }\n    ");
}, function (_a) {
    var active = _a.active;
    return (active ? '600' : '400');
});
var NavbarMenuListItem = function (props) {
    var label = props.label, _a = props.active, active = _a === void 0 ? false : _a, value = props.value, icon = props.icon, render = props.render, onClick = props.onClick, _b = props.disableHover, disableHover = _b === void 0 ? false : _b, trailingDivider = props.trailingDivider;
    var onItemClick = function () {
        if (disableHover)
            return;
        onClick === null || onClick === void 0 ? void 0 : onClick(value);
    };
    return (_jsxs(_Fragment, { children: [_jsx(NavbarListItem, __assign({ disableHover: disableHover, active: active, onClick: onItemClick }, { children: render ? (render(props)) : (_jsxs(_Fragment, { children: [icon !== null && icon !== void 0 ? icon : null, _jsx(Text, __assign({ variant: "body2", color: active ? 'neutral100' : 'neutral80' }, { children: label }))] })) })), trailingDivider && _jsx(Divider, { margin: 4 })] }));
};
export default NavbarMenuListItem;
var templateObject_1;
